import { pushNewsletterEvent } from "@grandvisionhq/content";
import { useMutation } from "@grandvisionhq/graphql";
import { useIntl } from "@grandvisionhq/state";
import { useNewsletterSubmit } from "./use-newsletter-submit.js";
import { SUBSCRIBE_NEWSLETTER } from "../../operations/mutations/operations/mutations/subscribe-newsletter.js";
const useSubscribeNewsletter = () => {
  const { locale } = useIntl();
  const [subscribeNewsletter, { data, error, loading }] = useMutation(SUBSCRIBE_NEWSLETTER, {
    context: {
      forwardHeaders: {
        "Accept-Language": locale
      }
    },
    onError: (error2) => {
      console.error(`Error occurred while executing the newsletter mutation: ${error2}`);
    },
    onCompleted: () => {
      pushNewsletterEvent({
        interactionType: "subscription_confirm_click",
        eventName: "newsletter_subscription_confirm"
      });
    }
  });
  const { onSubmit } = useNewsletterSubmit(subscribeNewsletter);
  const { failures, success } = data?.subscribeNewsletter || {};
  return {
    hasError: !!error || !!failures?.length,
    hasSubscribed: success || false,
    isLoading: loading,
    onSubmit
  };
};
export {
  useSubscribeNewsletter
};
//# sourceMappingURL=use-subscribe-newsletter.js.map
